import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from 'axios'

import ServerError from './common/500'
Vue.component('ServerError', ServerError)
import VueElementLoading from 'vue-element-loading'
Vue.component('VueElementLoading', VueElementLoading)
import { VueEditor } from "vue2-editor";

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel",JsonExcel);

Vue.component('VueEditor', VueEditor)

Vue.config.productionTip = false

// axios.defaults.baseURL = 'http://192.168.55.2:4004';
// Vue.prototype.baseURL = 'http://192.168.55.2:4004';
// Vue.prototype.mediaURLOld = 'http://192.168.55.2:4004';
// Vue.prototype.mediaURL = 'http://192.168.55.2:4004/file/get/';

// axios.defaults.baseURL = 'http://13.233.1.101';
// Vue.prototype.baseURL = 'http://13.233.1.101';
// Vue.prototype.mediaURLOld = 'http://13.233.1.101';
// Vue.prototype.mediaURL = 'http://13.233.1.101/file/get/';

axios.defaults.baseURL = 'http://shark.leopardtechlabs.in';
Vue.prototype.baseURL = 'http://shark.leopardtechlabs.in';
Vue.prototype.mediaURLOld = 'http://shark.leopardtechlabs.in';
Vue.prototype.mediaURL = 'http://shark.leopardtechlabs.in/file/get/';

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
